import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Switch,
    Route,
    Redirect,
    withRouter,
} from 'react-router-dom';
import classnames from 'classnames';


import CaseSelection from '../CaseSelection';
import SettlementReports from '../SettlementReports';
import GDGolbalFilter from 'Components/GDGolbalFilter';
import LandingPage from '../LandingPage';
import LandingPageNew from '../LandingPageNew';
import QueueLanding from '../QueueLanding';
import QueueManagementLanding from '../QueueManagementLanding/QueueManagementLanding';
import CreateCustomQueueLanding from '../CreateCustomQueueLanding/CreateCustomQueueLanding';
import CaseLanding from '../CaseLanding';
import CaseSearch from '../CaseSearch/CaseSearch';
import GlobalSearchLanding from '../GlobalSearchLanding/GlobalSearchLanding';
import CreateDocument from '../CreateDocument/CreateDocument';
import ProductivityReport from '../ProductivityReport';
import DetailedReport from '../ProductivityReport/DetailedReport';
import UnresolvedRTI from '../UnresolvedRTI';

import {
    getRecentSearchesData,
    getMerchantsData,
    getFavoritesData,
} from './testHierarchyMocks';

import ImageSelection from '../ImageSelection';
import AppSelection from '../AppSelection/AppSelection';
import AppSearch from '../AppSearch/AppSearch';
import OperationsReports from '../OperationsReports/OperationsReports';
import ProductReports from '../ProductReports/ProductReports';
import ReportView from '../ReportView/ReportView';

import './Main.scss';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import SubQueueLandingPage from '../OpenQueueLandingPage/SubQueueLandingPage';
import BaseQueueLanding from '../OpenQueueLandingPage/BaseQueueLanding';
import Insights from '../Insights/Insights';
import DailySummary from '../ProductivityReport/DailySummary/DailySummary';
import HourlySummary from '../ProductivityReport/HourlySummary/HourlySummary';
import MonthlySummary from '../ProductivityReport/MonthlySummary/MonthlySummary';
import FileImport from '../FileImport/FileImport';
import { VITE_OP1CASESELECTION } from 'Constants/appEnvConstants';

const mockedRecentSearches = getRecentSearchesData();
const mockedFavorites = getFavoritesData();
const mockedAvailableItems = getMerchantsData();

class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHierarchySelectorOverlayVisible: false,
            searchTypeId: null,
            isCaseSearchCalled: false,
            role: JSON.parse(sessionStorage.getItem('state')).auth.user.role.key,
            internalEmployees: ['DiMS_INTERNAL_EMPLOYEE'],
            fileImportPermittedUsers: ['DiMS_DISPUTE_MANAGER', 'DiMS_PRODUCTION_SUPPORT', 'DiMS_DISPUTE_PRODUCT_MANAGER'],
        };

        this.attachBindings();
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onKeyPress);
        document.addEventListener('keypress', this.onKeyPress);
        if (this.state.internalEmployees.findIndex(internalEmp => internalEmp == this.state.role) != -1) {
            this.setState({
                isInternalEmployee: true
            })
        }
        if (this.state.fileImportPermittedUsers.findIndex(userRole => userRole == this.state.role) != -1) {
            this.setState({
                isfileImportPermittedUsers: true
            })
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress);
        document.removeEventListener('keypress', this.onKeyPress);
    }

    componentWillReceiveProps(nextprops) {
        if (this.props.location.pathname !== nextprops.location.pathname) {
            this.setState({
                searchTypeId: null,
            });
        }
    }

    onKeyPress(event) {
        const eventCode = event.code ? (event.code + "_" + event.ctrlKey + "_" + event.altKey) : event.key + "_" + event.ctrlKey + "_" + event.altKey;
        var selectedValue = "";
        switch (eventCode) {
            case KeyConstants.CTRL_ALT_DIGIT0:
            case KeyConstants.CTRL_ALT_NUMPAD0:
                this.setState({
                    isCaseSearchCalled: true,
                });
                document.getElementById('selectDataSearch').click();
                break;
            case KeyConstants.CTRL_ALT_DIGIT1:
            case KeyConstants.CTRL_ALT_NUMPAD1:
                selectedValue = "1";
                break;
            case KeyConstants.CTRL_ALT_DIGIT2:
            case KeyConstants.CTRL_ALT_NUMPAD2:
                selectedValue = "2";

                break;
            case KeyConstants.CTRL_ALT_DIGIT3:
            case KeyConstants.CTRL_ALT_NUMPAD3:
                selectedValue = "3";

                break;
            case KeyConstants.CTRL_LETTERF:
                this.props.setDrawerOpenFlag(false);
                this.props.history.push({ pathname: '/casesearch' });

                break;
        }
        selectedValue && this.setSearchType(selectedValue);
    }

    setSearchType(searchTypeId) {
        this.setState({
            searchTypeId,
        });
    }

    handleRefresh() {
        this.forceUpdate();
    }

    handleCollapse() {
        this.setState({
            isHierarchySelectorOverlayVisible: false,
        });
    }

    handleExpand() {
        this.setState({
            isHierarchySelectorOverlayVisible: true,
        });
    }

    handleApply(items) {
        this.props.globalFilterActions.clearGlobalFilter();
        this.props.globalFilterActions.addToGlobalFilterOrgIds(items);
        this.forceUpdate();
    }

    handleSave(name, items) {
        return this.props.filterActions.saveHierarchySelectorFilter(name, items)
            .then(() => {
                this.props.filterActions.getHierarchySelectorFilters();
            });
    }

    handleDelete() {
        console.log('handleDelete');
    }

    attachBindings() {
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleCollapse = this.handleCollapse.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.setSearchType = this.setSearchType.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    render() {
        const wrapperClass = classnames('center-section', this.props.overlayClass);
        let acquirerList = getAcquirerAccessList();
        return (
            <section className={wrapperClass}>
                <div className="global-filter-bar">
                    {
                        (!this.props?.user?.parsedPermissions?.queue?.canViewAll || acquirerList.length !== 0) &&
                        <GDGolbalFilter
                            availableItems={mockedAvailableItems}
                            extraClass="some-class"
                            itemNameColumnName="businessName"
                            itemNumberColumnName="merchantNumber"
                            onApplySelections={this.handleApply}
                            onCollapse={this.handleCollapse}
                            onDeleteFilter={this.handleDelete}
                            onExpand={this.handleExpand}
                            onSaveFilter={this.handleSave}
                            recentSearches={mockedRecentSearches}
                            savedSelections={mockedFavorites}
                            typeIds="merchantIds"
                            isMerchantUser={false}
                        />
                    }
                    <AppSelection setSearchType={this.setSearchType} />
                </div>
                <div className="mobile-message">
                    <svg version="1.1" id="mobile-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1366 912">
                        <path d="M1322.8,8c19.4,0,35.2,15.8,35.2,35.2v825.6c0,19.4-15.8,35.2-35.2,35.2H43.2C23.8,904,8,888.2,8,868.8V43.2C8,23.8,23.8,8,43.2,8H1322.8 M72,839.7h8h1110h8v-8V80.3v-8h-8H80h-8v8v751.4V839.7 M1322.8,0H43.2C19.4,0,0,19.4,0,43.2v825.6C0,892.6,19.4,912,43.2,912h1279.6c23.8,0,43.2-19.4,43.2-43.2V43.2C1366,19.4,1346.6,0,1322.8,0L1322.8,0z M80,831.7V80.3h1110v751.4H80L80,831.7z" />
                        <path d="M1274,411c24.8,0,45,20.2,45,45s-20.2,45-45,45s-45-20.2-45-45S1249.2,411,1274,411 M1274,403c-29.3,0-53,23.7-53,53s23.7,53,53,53s53-23.7,53-53S1303.3,403,1274,403L1274,403z" />
                        <path d="M1288.3,441.7v28.6h-28.6v-28.6H1288.3 M1296.3,433.7h-44.6v44.6h44.6V433.7L1296.3,433.7z" />
                    </svg>
                    <p>
                        This content must be viewed on a larger screen.
            <span>(Landscape iPad or larger.)</span>
                    </p>
                </div>

                <main role="main" className="main-content" style={{overflowY:"auto", overflowX:"hidden"}}>
                    {this.state.searchTypeId !== null && this.state.searchTypeId !== undefined
                        && (
                            <AppSearch
                                {...this.props}
                                searchTypeId={this.state.searchTypeId}
                                setSearchType={this.setSearchType}
                            />
                        )
                    }

                    <Switch>
                        <Route
                            path="/reports/operations"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <OperationsReports {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />

                        <Route
                            path="/reports/productreport"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <ProductReports {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                         
                        <Route
                            path="/reports/view/"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <ReportView {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />

                        <Route
                            path="/reports/settlement"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <SettlementReports {...props}
                                    reportName={'Settlement Reports'} />
                            ) : <Redirect to="/casesearch" />}
                        />


                        <Route
                            path="/reports/inventory"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <SettlementReports {...props}
                                reportName={this.props.location?.state?.reportName} />
                            ) : <Redirect to="/casesearch" />}
                        />

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.canViewAll &&
                            <Route
                                path="/landing"
                                render={(props) => !this.state.isInternalEmployee ? (
                                    <LandingPageNew {...props} />
                                ) : <Redirect to="/casesearch" />}
                            />
                        }

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewUnresolvedRTIReport &&
                            <Route
                                path="/unresolve"
                                render={(props) => !this.state.isInternalEmployee ? (
                                    <UnresolvedRTI {...props} />
                                ) : <Redirect to="/casesearch" />}
                            />
                        }

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.createQueue &&
                            <Route
                                path="/customQueue"
                                render={(props) => !this.state.isInternalEmployee ? (
                                    <CreateCustomQueueLanding {...props} />
                                ) : <Redirect to="/casesearch" />}
                            />
                        }
                        {this.props.user !== undefined && this.state.isfileImportPermittedUsers &&
                            <Route
                                path="/fileImport"
                                render={(props) => !this.state.isInternalEmployee ? (
                                    <FileImport user={this.props.user} />
                                ) : <Redirect to="/casesearch" />}
                            />
                        }

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.seeStatsForQueue &&
                            <Route
                                path="/insights"
                                render={(props) => !this.state.isInternalEmployee ? (
                                    <Insights {...props} />
                                ) : <Redirect to="/casesearch" />}
                            />
                        }

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewProductivityReport &&
                        <Route
                            path="/reports/productivityreport"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <ProductivityReport {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        }
                        
                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewProductivityReport &&
                        <Route
                            path="/reports/detailedreport"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <DetailedReport {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        }
                        
                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewProductivityReport &&
                        <Route
                            path="/reports/dailysummary"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <DailySummary {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        }

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewProductivityReport &&
                        <Route
                            path="/reports/hourlysummary"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <HourlySummary {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        }

                        {this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewProductivityReport &&
                        <Route
                            path="/reports/monthlysummary"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <MonthlySummary {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        }

                        <Route
                            path="/dashboard"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <LandingPageNew {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />


                        <Route
                            path="/casesearch"
                            render={(props) => (
                                <CaseSearch
                                    history={props.history}
                                    location={props.location}
                                />
                            )}
                        />
                        <Route
                            key='caseselection'
                            path="/queue/:queueId(\d+)/caseselection/:caseNumber(\d+)"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <CaseSelection {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        <Route
                            key={VITE_OP1CASESELECTION}
                            path="/caselanding/casestage/queue/:queueId(\d+)/caseselection/:caseNumber(\d+)"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <CaseSelection {...props} />
                            ) : <Redirect to="/casesearch" />}
                        />
                        <Route
                            path="/queue/:queueId(\d+)/imageselection"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <ImageSelection
                                    history={props.history}
                                    location={props.location}
                                    navCollapsed={this.props.navCollapsed}
                                />
                            ) : <Redirect to="/casesearch" />}
                        />
                        <Route
                            key='caselanding'
                            path="/caselanding/:caseNumber(\d+)"
                            render={(props) => (
                                <CaseLanding
                                    {...this.props}
                                    caseNumber={props.match.params.caseNumber}
                                    history={props.history}
                                    location={props.location}
                                    selectedListOption={this.state.selectedListOption}
                                    setListOption={this.setListOption}
                                    setSearchType={this.setSearchType}
                                />
                            )}
                        />
                        <Route
                            key='op1caselanding'
                            path="/caselanding/casestage/:caseStageId(\d+)"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <CaseLanding
                                    {...this.props}
                                    caseStageId={props.match.params.caseStageId}
                                    history={props.history}
                                    location={props.location}
                                    selectedListOption={this.state.selectedListOption}
                                    setListOption={this.setListOption}
                                />
                            ) : <Redirect to="/casesearch" />}
                        />
                        <Route
                            path="/queue/:queueId(\d+)"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <QueueLanding
                                    history={props.history}
                                    location={props.location}
                                    queueId={props.match.params.queueId}
                                />
                            ) : <Redirect to="/casesearch" />}
                        />


                        <Route
                            path="/queue-management-landing/"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <QueueManagementLanding history={props.history}
                                    location={props.location} />
                            ) : <Redirect to="/casesearch" />}
                        />

                        <Route
                            path="/base-queue-landing/"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <BaseQueueLanding
                                    history={props.history}
                                    location={props.location} />
                            ) : <Redirect to="/casesearch" />}
                        />

                        <Route
                            path="/sub-queue-landing-page"
                            render={(props) => !this.state.isInternalEmployee ? (
                                <SubQueueLandingPage
                                    history={props.history}
                                    location={props.location} />
                            ) : <Redirect to="/casesearch" />}
                        />

                        <Route
                            path="/globalsearch/:searchkey/:searchType"
                            render={(props) => (
                                <GlobalSearchLanding {...props} />
                            )}
                        />

                        <Route
                            key='createdocument'
                            path="/createdocument/:caseNumber"
                            render={(props) => (
                                <CreateDocument {...this.props}
                                    caseNumber={props.match.params.caseNumber} />
                            )}
                        />

                        {!this.state.isInternalEmployee ? <Redirect path="*" to="/dashboard" /> : <Redirect path="*" to="/casesearch" />}
                    </Switch>

                </main>
            </section>
        );
    }
}


Main.propTypes = {
    overlayClass: PropTypes.string.isRequired,
    parsedPermissions: PropTypes.object.isRequired,
    termsAccepted: PropTypes.bool.isRequired,
    resetScrollPos: PropTypes.func.isRequired,
    toggleNav: PropTypes.bool,
};

Main.defaultProps = {
    toggleNav: true,
};

export default withRouter(Main);
